// Install the angularjs.TypeScript.DefinitelyTyped NuGet package
module App {
    "use strict";

    interface IConfirmationModalScope extends ng.IScope {
        title: string;
        content: string;
        confirmYes: () => void;
        confirmNo: () => void;
    }

    interface IConfirmationModal {
       
        activate: () => void;
    }

    class ConfirmationModal implements IConfirmationModal {
        static controllerId: string = "confirmationModal";
        
        static $inject: string[] = ["$scope", "$uibModalInstance", "data"];

        constructor(private $scope: IConfirmationModalScope, private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, private data) {
            $scope.title = data.title;
            $scope.content = data.content;
            $scope.confirmYes = this.confirmYes;
            $scope.confirmNo = this.confirmNo;
            this.activate();
        }

        activate() {

        }

        confirmYes = () => {
            this.$uibModalInstance.close(true);
        }

        confirmNo = () => {
            this.$uibModalInstance.close(false);
        }
    }

    angular.module("app").controller(ConfirmationModal.controllerId, ConfirmationModal);
}